export const SPECIALIZATION_LABELS = {
  vedic_astrology_specialist: 'Vedic Astrology Specialist',
  kp_astrology_practitioner: 'KP Astrology Practitioner',
  numerology_expert: 'Numerology Expert',
  tarot_reader: 'Tarot Reader',
  palmist: 'Palmist',
  vastu_expert: 'Vastu Expert'
}

export const LANGUAGE_LABELS = {
  english: 'English',
  hindi: 'Hindi',
  bengali: 'Bengali',
  gujarati: 'Gujarati',
  kannada: 'Kannada',
  malayalam: 'Malayalam',
  marathi: 'Marathi',
  punjabi: 'Punjabi',
  tamil: 'Tamil',
  telugu: 'Telugu',
  urdu: 'Urdu'
} 